import { isPlatformServer } from '@angular/common';
import { Injectable, Inject, DOCUMENT, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VideoToThumbnailService {

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) protected _platformId: Object
  ) { }

  public generateThumbnail(videoFile: Blob): Promise<string> {
    console.log('Generating thumbnail for video file:', videoFile);
    if (isPlatformServer(this._platformId))
      return Promise.reject('Thumbnail generation is not supported on the server.');

    console.log('Creating video and canvas elements for thumbnail generation.');


    const video: HTMLVideoElement = this.document.createElement('video');
    const canvas: HTMLCanvasElement = this.document.createElement('canvas');
    const context: CanvasRenderingContext2D = canvas.getContext('2d');
    return new Promise<string>((resolve, reject) => {
      canvas.addEventListener('error', reject);
      video.addEventListener('error', reject);
      video.addEventListener('canplay', event => {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
        resolve(canvas.toDataURL());
      });
      if (videoFile.type) {
        video.setAttribute('type', videoFile.type);
      }
      video.preload = 'auto';
      video.src = window.URL.createObjectURL(videoFile);
      video.load();
    });
  }
}
